import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import DialogModal from "../../common/DialogModal";
import OwnerShipLabel from "../../common/OwnerShip/OwnerShipLabel";
import { Link } from "react-router-dom";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import { formatPostcode } from "../../../utils/utils";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "25px",
    margin: 0,
    textAlign: "left",
  },

  desc: {
    fontSize: "13px",
    padding: "20px",
    marginBottom: "16px",
    background: "#1A65FF0D",
  },

  url: {
    textDecoration: "none",
    color: "#1A65FF",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  emptyContainer: {
    padding: "50px",
    position: "relative",
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    boxSizing: "border-box",
    width: "100%",
  },

  container: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderBottom: "0px",
  },

  row: {
    padding: "15px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    borderBottom: "1px solid #D8DBDF",
    boxSizing: "border-box",
  },

  linkBtn: {
    color: "#1A65FF",
    fontSize: "15px",
    fontWeight: "bold",
    width: "unset",
    height: "unset",
    minHeight: "unset",
    padding: 0,
    float: "right",
    marginTop: "15px",
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "none !important",
    },
  },

  left: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },

  selectBtn: {
    color: "#1A65FF",
    border: "1px solid #1A65FF",
    fontSize: "13px",
    padding: "10px 18px",
    minHeight: "unset",
    "&:hover": {
      backgroundColor: "none !important",
    },
  },

  selectBtnDisabled: {
    color: "#181819",
    border: "1px solid #D8DBDF",
    fontSize: "13px",
    padding: "10px 18px",
    minHeight: "unset",
  },
});

class SelectSenderDialog extends React.Component {
  renderRow = (sender, i) => {
    const { classes } = this.props;
    const isSelected = this.props.selectedSenderId === sender.id;

    return (
      <div className={classes.row} key={i}>
        <div className={classes.left}>
          {sender.post_code && (
            <Typography variant="body2" className={classes.leftCardText}>
              {formatPostcode(sender.post_code)}
            </Typography>
          )}
          {sender.address && (
            <Typography variant="body2" className={classes.leftCardText}>
              {sender.address}
            </Typography>
          )}
          {(sender.address || sender.post_code) && (
            <span style={{ display: "block", marginTop: "10px" }}></span>
          )}
          {sender.company && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${sender.company}`}</Typography>
          )}
          {sender.branch && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${sender.branch}`}</Typography>
          )}
          {sender.position && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${sender.position}`}</Typography>
          )}
          {sender.name && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${sender.name}`}</Typography>
          )}
          <OwnerShipLabel name={sender.ownership_user_name} />
        </div>
        <div className={classes.right}>
          <Button
            className={classes.selectBtn}
            color="primary"
            onClick={() => {
              this.props.selectSender(isSelected ? {} : sender);
              this.props.toggleDialog();
            }}
          >
            {isSelected ? "選択から外す" : "この差出人を選択"}
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        title="差出人を編集"
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.desc}>
          差出人情報の管理は
          <Link className={classes.url} to="/setting">
            アカウント管理
          </Link>
          より行えます。
        </div>
        {(() => {
          if (this.props.senders.length === 0) {
            return (
              <div className={classes.emptyContainer}>
                <Typography variant="body2" style={{ color: "#71737B" }}>
                  差出人はありません。
                </Typography>
              </div>
            );
          } else {
            return (
              <div className={classes.container}>
                {this.props.senders.map((sender, i) =>
                  this.renderRow(sender, i)
                )}
              </div>
            );
          }
        })()}
        <div className={classes.buttonContainer}>
          <Button
            variant="flat"
            color="primary"
            className={classes.linkBtn}
            onClick={this.props.toggleEditSenderDialog}
          >
            差出人を新規登録
          </Button>
        </div>
      </DialogModal>
    );
  }
}

SelectSenderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  senders: PropTypes.array.isRequired,
  selectedSenderId: PropTypes.string.isRequired,
  selectSender: PropTypes.func.isRequired,
  toggleEditSenderDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(SelectSenderDialog);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/SelectSenderDialog.jsx